import { render, staticRenderFns } from "./CorporateTopNotifications.vue?vue&type=template&id=389ebc72&scoped=true&"
import script from "./CorporateTopNotifications.vue?vue&type=script&lang=ts&"
export * from "./CorporateTopNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./CorporateTopNotifications.vue?vue&type=style&index=0&id=389ebc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ebc72",
  null
  
)

export default component.exports